import ApiService from "../ApiService";

const ReminderService = {
  getReminders(reminderDate, page, perPage, searchString) {
    return ApiService.get(
      `/reminders?reminderDate=${reminderDate}&page=${page}&perPage=${perPage}&searchString=${searchString}`
    );
  },

  saveReminder(id, patientId, userId, reminderDate, observation, seen) {
    return ApiService.post("/reminders", {
      id,
      patientId,
      userId,
      reminderDate,
      observation,
      seen
    });
  }
};

export default ReminderService;
